import { createForm } from '../../../factories'

export default createForm(['moduleIDs'])



// WEBPACK FOOTER //
// ./src/store/modules/groups/forms/relateModules.js